import React, { useEffect, useState } from "react";
import UploadFile from "../Components/uploadFile";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Button,
  Input,
  Label,
} from "reactstrap";

import {
  getAds,
  addAd,
  updateAd,
  deleteAd,
  getUniqueLocations,
} from "../../services/api/api-service";

const Ads = () => {
  const [ads, setAds] = useState([]);

  const [title, setTitle] = useState("");
  const [image, setImage] = useState("");
  const [link, setLink] = useState("");
  const [city, setCity] = useState("");

  const [placement, setPlacement] = useState("HOME");
  const [showOnHome, setShowOnHome] = useState(true);

  const [cities, setCities] = useState([]);
  const [editingId, setEditingId] = useState(null);



  const handleAdImageUpload = (input) => {
  if (!input || typeof input !== "string") {
    alert("Image upload failed. Please try again.");
    return;
  }

  console.log("Ad Image Uploaded:", input);

  setImage(input);
};

  // ==============================
  // LOAD CITIES
  // ==============================
 const loadCities = async (selectedPlacement) => {
  try {
    if (selectedPlacement === "TRANSPORTER") {
      const response = await getUniqueLocations(["Transporter"]);

      //console.log("📍 TRANSPORTER RESPONSE:", response);
      //console.log("📍 TRANSPORTER CITY ARRAY:", response?.city);

      if (Array.isArray(response?.city)) {
        setCities(response.city);
      } else {
        setCities([]);
      }

    } else if (selectedPlacement === "PACKERS") {
      const response = await getUniqueLocations([
        "Packers And Movers",
      ]);

      //console.log("📍 PACKERS RESPONSE:", response);
      //console.log("📍 PACKERS CITY ARRAY:", response?.city);

      if (Array.isArray(response?.city)) {
        setCities(response.city);
      } else {
        setCities([]);
      }

    } else {
      setCities([]);
    }
  } catch (error) {
    //console.log("❌ Error loading cities:", error);
    setCities([]);
  }
};

  // ==============================
  // LOAD ADS
  // ==============================
  const loadAds = async () => {
    try {
      const data = await getAds();

      if (Array.isArray(data)) {
        setAds(data);
      } else if (Array.isArray(data?.result)) {
        setAds(data.result);
      } else if (Array.isArray(data?.data)) {
        setAds(data.data);
      } else {
        setAds([]);
      }
    } catch (error) {
      console.log("❌ Error loading ads:", error);
      setAds([]);
    }
  };

  useEffect(() => {
    loadAds();
    loadCities("HOME");
  }, []);

  // ==============================
  // PLACEMENT CHANGE
  // ==============================
  const handlePlacementChange = async (value) => {
  //console.log("🔄 Placement changed:", value);

  setPlacement(value);
  setCity("");

  await loadCities(value);
};
  // ==============================
  // RESET FORM
  // ==============================
  const resetForm = () => {
    setTitle("");
    setImage("");
    setLink("");
    setCity("");
    setPlacement("HOME");
    setShowOnHome(true);
    setEditingId(null);
    setCities([]);
  };

  // ==============================
  // SAVE / UPDATE
  // ==============================
  const handleSave = async () => {
    if (!title.trim()) {
      alert("Please enter ad title.");
      return;
    }

    if (!image.trim()) {
      alert("Please enter image URL.");
      return;
    }

    if (
      (placement === "TRANSPORTER" ||
        placement === "PACKERS") &&
      !city
    ) {
      alert("Please select city.");
      return;
    }

    const payload = {
      title: title.trim(),
      image: image.trim(),
      link: link.trim(),
      city:
        placement === "HOME"
          ? ""
          : city.trim(),
      placement,
      showOnHome,
      status: "active",
      date: new Date(),
    };

    try {
      if (editingId) {
        await updateAd(editingId, payload);
        alert("Ad updated successfully.");
      } else {
        await addAd(payload);
        alert("Ad added successfully.");
      }

      resetForm();
      await loadAds();
    } catch (error) {
      console.log("❌ Error saving ad:", error);
      alert("Failed to save ad.");
    }
  };

  // ==============================
  // EDIT
  // ==============================
  const handleEdit = async (ad) => {
    const adPlacement =
      ad?.placement?.trim().toUpperCase() || "HOME";

    setEditingId(ad.id);
    setTitle(ad.title || "");
    setImage(ad.image || "");
    setLink(ad.link || "");
    setCity(ad.city || "");
    setPlacement(adPlacement);

    // Old ads without showOnHome are treated as true
    setShowOnHome(ad.showOnHome !== false);

    await loadCities(adPlacement);
  };

  // ==============================
  // DELETE
  // ==============================
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this ad?")) {
      return;
    }

    try {
      await deleteAd(id);
      alert("Ad deleted successfully.");
      await loadAds();
    } catch (error) {
      console.log("❌ Error deleting ad:", error);
      alert("Failed to delete ad.");
    }
  };

  // ==============================
  // PLACEMENT LABEL
  // ==============================
  const getPlacementLabel = (value) => {
    switch (value) {
      case "TRANSPORTER":
        return "Transporter Directory";

      case "PACKERS":
        return "Packers & Movers Directory";

      case "HOME":
      default:
        return "Home / General Pages";
    }
  };

  return (
    <Container fluid>
      <Row>
        <Col md="12">
          <Card>
            <CardBody>
              <CardTitle tag="h4">
                {editingId ? "Edit Ad" : "Add New Ad"}
              </CardTitle>

              {/* AD TITLE */}
              <div className="mb-3">
                <Label>Ad Title</Label>
                <Input
                  type="text"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                  placeholder="Enter ad title"
                />
              </div>

             {/* AD IMAGE UPLOAD */}
<div className="mb-3">
  <Label>Upload Advertisement Image</Label>

  <UploadFile
    labelValue="Select Advertisement Image"
    bucketName="moverstrip-prod"
    UploadPath="static/ads/"
    fileValue={handleAdImageUpload}
    currentImage={image || null}
  />

  {image && (
    <div className="mt-3">
      <Label>Uploaded Image </Label>

      <div>
        <img
          src={image}
          alt="Advertisement"
          style={{
            width: "250px",
            height: "140px",
            objectFit: "cover",
            borderRadius: "8px",
            border: "1px solid #ddd",
          }}
        />
      </div>
    </div>
  )}
</div>
              {/* LINK */}
              <div className="mb-3">
                <Label>Redirect Link</Label>
                <Input
                  type="text"
                  value={link}
                  onChange={(e) => setLink(e.target.value)}
                  placeholder="https://..."
                />
              </div>

              {/* PLACEMENT */}
              <div className="mb-3">
                <Label>Show Ad In</Label>

                <Input
                  type="select"
                  value={placement}
                  onChange={(e) =>
                    handlePlacementChange(e.target.value)
                  }
                >
                  <option value="HOME">
                    Home / General Pages
                  </option>

                  <option value="TRANSPORTER">
                    Transporter Directory
                  </option>

                  <option value="PACKERS">
                    Packers & Movers Directory
                  </option>
                </Input>
              </div>

              {/* CITY */}
              {(placement === "TRANSPORTER" ||
  placement === "PACKERS") && (
  <div className="mb-3">
    <Label>City</Label>

    <Input
      type="select"
      value={city}
      onChange={(e) => setCity(e.target.value)}
    >
      <option value="">Select City</option>

      {Array.isArray(cities) &&
        cities.map((item, index) => (
          <option
            key={item?.value || index}
            value={item?.value || ""}
          >
            {item?.label || item?.value || ""}
          </option>
        ))}
    </Input>
  </div>
)}

              {/* SHOW ON HOME */}
              <div className="mb-3">
                <Label>Show On Home</Label>

                <Input
                  type="select"
                  value={showOnHome ? "true" : "false"}
                  onChange={(e) =>
                    setShowOnHome(
                      e.target.value === "true"
                    )
                  }
                >
                  <option value="true">Yes</option>
                  <option value="false">No</option>
                </Input>
              </div>

              {/* BUTTONS */}
              <Button
                color="primary"
                onClick={handleSave}
                className="me-2"
              >
                {editingId ? "Update Ad" : "Add Ad"}
              </Button>

              {editingId && (
                <Button
                  color="secondary"
                  onClick={resetForm}
                >
                  Cancel
                </Button>
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>

      {/* AD LIST */}
      <Row className="mt-4">
        {ads.map((ad) => {
          const adPlacement =
            ad?.placement?.trim().toUpperCase() || "HOME";

          return (
            <Col md="4" key={ad.id} className="mb-4">
              <Card>
                <CardBody>
                  <img
                    src={ad.image}
                    alt={ad.title}
                    style={{
                      width: "100%",
                      height: "180px",
                      objectFit: "cover",
                      borderRadius: "8px",
                    }}
                  />

                  <h5 className="mt-3">
                    {ad.title}
                  </h5>

                  <p>
                    <strong>Show In:</strong>{" "}
                    {getPlacementLabel(adPlacement)}
                  </p>

                  {ad.city && (
                    <p>
                      <strong>City:</strong>{" "}
                      {ad.city}
                    </p>
                  )}

                  <p>
                    <strong>Show On Home:</strong>{" "}
                    {ad.showOnHome !== false
                      ? "Yes"
                      : "No"}
                  </p>

                  {ad.link && (
                    <p
                      style={{
                        wordBreak: "break-all",
                      }}
                    >
                      <strong>Link:</strong>{" "}
                      {ad.link}
                    </p>
                  )}

                  <Button
                    color="warning"
                    size="sm"
                    className="me-2"
                    onClick={() => handleEdit(ad)}
                  >
                    Edit
                  </Button>

                  <Button
                    color="danger"
                    size="sm"
                    onClick={() =>
                      handleDelete(ad.id)
                    }
                  >
                    Delete
                  </Button>
                </CardBody>
              </Card>
            </Col>
          );
        })}
      </Row>
    </Container>
  );
};

export default Ads;